// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/Campaigns/components/CampaignCards/CouponNotificationCard/CouponNotificationCard.css
// module id = 498
// module chunks = 0